import React, { useMemo, useState } from "react";
import useSWRMutation from "swr/mutation";
import { Button } from "../../components/ui/button";
import { useNavigate } from "react-router-dom";
import requestErrorHandler from "../../util/requestErrorHandler";
import { handleMutation } from "../../util/axios";
import { message } from "antd";
import { Password } from "../../components/ui/Password";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    oldPassword: "",
    password: "",
    confirmPassword: ""
  });

  const isInValidPassword = useMemo(() => {
    return formData.password && formData.password !== formData.confirmPassword
  }, [formData]);

  const { trigger, isMutating } = useSWRMutation(
    "fleet/password-reset",
    handleMutation
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await trigger({
        newPassword: formData.password,
        oldPassword: formData.oldPassword
      });

      if (!res) return;
      message.success("Password reset successful");
      navigate('/settings')
    } catch (err: any) {
      requestErrorHandler(err);
      console.error("Login error:", err);
    }
  };

  return (
    <div className="h-full max-w-md mx-auto flex flex-col justify-center p-4 md:p-8 space-y-8">
      <h1 className="text-xl md:text-2xl font-bold md:mb-10 text-center">Reset Password</h1>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="space-y-4">
          <div className="space-y-2">
            <label htmlFor="password" className="block font-medium">
              Old Password
            </label>
            <Password
              id="oldPassword"
              name="oldPassword"
              type="password"
              placeholder="Enter old password"
              value={formData.oldPassword}
              onChange={handleChange}
              required
              className="bg-gray-200 border-none"
            />
          </div>
          <div className="space-y-2">
            <label htmlFor="password" className="block font-medium">
              Password
            </label>
            <Password
              id="password"
              name="password"
              type="password"
              placeholder="Enter password"
              value={formData.password}
              onChange={handleChange}
              required
              className="bg-gray-200 border-none"
            />
          </div>
          <div className="space-y-2">
            <label htmlFor="password" className="block font-medium">
              Password
            </label>
            <Password
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              placeholder="Enter password"
              value={formData.confirmPassword}
              onChange={handleChange}
              className="bg-gray-200 border-none"
              required
            />
          </div>

          {isInValidPassword && <p className="text-red-500 text-sm">
            Error! password and confirm password do not match!
          </p>}
        </div>

        <div className="flex items-center justify-between gap-4">
          <Button
            type="reset"
            variant="ghost"
            className="text-orange-500 mt-8"
            onClick={(e) => {
                e.preventDefault();
                navigate(-1);
            }}
          >
            Cancel
          </Button>            
          <Button
            disabled={isMutating}
            type="submit"
            className="text-lg bg-blue-600 hover:bg-blue-700 text-white py-2 mt-8"
          >
            {isMutating ? "Loading..." : "Submit"}
          </Button>
        </div>
      </form>
    </div>
  );
}
